import React from 'react';
import { useTranslation } from '../../../i18n/provider';
import styles from './WorkoutCompletionModal.module.css';

interface WorkoutCompletionModalProps {
  isOpen: boolean;
  onClose: () => void;
  workoutDate: string;
}

export const WorkoutCompletionModal: React.FC<WorkoutCompletionModalProps> = ({
  isOpen,
  onClose,
  workoutDate
}) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <div className={styles.successIcon}>✅</div>
          <h2 className={styles.modalTitle}>{t('workout.completion.title')}</h2>
        </div>
        
        <div className={styles.modalContent}>
          <p className={styles.modalMessage}>
            {t('workout.completion.message', { date: workoutDate })}
          </p>
          <p className={styles.modalSubMessage}>
            {t('workout.completion.subMessage')}
          </p>
        </div>
        
        <div className={styles.modalActions}>
          <button 
            className={styles.primaryButton}
            onClick={onClose}
          >
            {t('workout.completion.acknowledge')}
          </button>
        </div>
      </div>
    </div>
  );
};
